import type { Ref } from 'vue';

import { watch } from 'vue';

export interface UseAutocompleteFieldComposable {
  handleEnterKeydown: () => void;
}

export interface Props {
  modelValue?: unknown | null;
}

export default function useAutocompleteField(
  fieldValue: Ref<unknown | null | undefined>,
  search: Ref<string> | null | undefined,
  field: Ref<HTMLFormElement | null>,
): UseAutocompleteFieldComposable {
  if (search) {
    watch(fieldValue, (newFieldValue) => {
      // workaround for deleting all symbols by editing input (last symbol was stayed or all symbols were visible after deleting)
      // not actualy needed if `multiple` is set
      if (fieldValue.value === newFieldValue && newFieldValue === null) {
        search.value = '';
      }
    });
  }

  function handleEnterKeydown(): void {
    // don't open autocomplete menu by Enter (immediately close)
    if (field.value) {
      field.value.menu = false;
    }
  }

  return {
    handleEnterKeydown,
  };
}
